export default function applyRegex(text, regex) {
    const finalText = text.match(regex);

    if (finalText) {
        return finalText.join('');
    } else {
        return '';
    }
}